import api from './api';

export const pathologyResultService = {
  // Search eligible pathology tests in worklist
  searchWorklist: async (params = {}) => {
    const response = await api.get('/pathology-results/worklist', { params });
    return response.data;
  },

  // Get workbench KPI metrics
  getSummary: async () => {
    const response = await api.get('/pathology-results/summary');
    return response.data;
  },

  // Retrieve full test order metadata and dynamically resolved observation form
  getTestResultForm: async (testId) => {
    const response = await api.get(`/pathology-results/${testId}`);
    return response.data;
  },

  // Save partial or complete draft results
  saveDraft: async (testId, data) => {
    const response = await api.post(`/pathology-results/${testId}/save-draft`, data);
    return response.data;
  },

  // Finalize and approve test report
  finalizeResult: async (testId, data) => {
    const response = await api.post(`/pathology-results/${testId}/finalize`, data);
    return response.data;
  },

  // Revise an already finalized report with mandatory clinical reason
  reviseResult: async (testId, data) => {
    const response = await api.post(`/pathology-results/${testId}/revise`, data);
    return response.data;
  },

  // Get parameter-level delta audit trail
  getAuditTrail: async (testId) => {
    const response = await api.get(`/pathology-results/${testId}/audit-trail`);
    return response.data;
  },

  // Get parameter-wise historical trend and delta check metrics
  getParameterHistory: async (patientId, labObservationId, currentTestId = null, limit = 5) => {
    const params = { patientId, labObservationId, limit };
    if (currentTestId) params.currentTestId = currentTestId;
    const response = await api.get('/pathology-results/parameter-history', { params });
    return response.data;
  },

  // Get prior patient laboratory investigation and encounter history
  getPatientHistory: async (patientId, excludeLabNo = null, excludeTestId = null) => {
    const params = { patientId };
    if (excludeLabNo) params.excludeLabNo = excludeLabNo;
    if (excludeTestId) params.excludeTestId = excludeTestId;
    const response = await api.get('/pathology-results/patient-history', { params });
    return response.data;
  },

  // Get all tests ordered under a patient visit/ledger transaction (including in-house, outsourced, and rejected)
  getOrderTests: async (ledgerTransactionNo) => {
    const response = await api.get(`/pathology-results/order-tests/${encodeURIComponent(ledgerTransactionNo)}`);
    return response.data;
  },
};

export default pathologyResultService;
